import { gql } from '@apollo/client';

export const GET_ACTIVE_FILE_NUMBERS = gql`
  query GetActiveFileNumbers($maxResults: Int) {
    getActiveFileNumbers(maxResults: $maxResults)
  }
`;
